import { createReducer, on } from '@ngrx/store';
import {
  LoadUserSearchResults,
  SetUserSearchResults,
  SetUserSearchError,
} from './user-search.actions';
import {
  AdminOrganizationUser,
  OrganizationMetadata,
} from 'src/app/admin/models/organization.model';
import { UserSearchApiError } from './user-search.errors';

export const enum CallState {
  INIT = 'INIT',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}

export interface UserSearchResult extends AdminOrganizationUser {
  lastLoggedInOrganization: OrganizationMetadata;
  organizationAccessesSorted: OrganizationMetadata[];
}

export interface UserSearchState {
  userSearchResult: AdminOrganizationUser;
  callState: CallState;
  apiError: UserSearchApiError;
}

export const initialState: UserSearchState = {
  userSearchResult: null,
  callState: CallState.INIT,
  apiError: null,
};

export const userSearchReducer = createReducer(
  initialState,
  on(LoadUserSearchResults, () => ({ ...initialState, callState: CallState.LOADING })),
  on(SetUserSearchResults, (state, { user }) => ({
    ...state,
    callState: CallState.LOADED,
    userSearchResult: user,
  })),
  on(SetUserSearchError, (state, { error }) => ({
    ...state,
    callState: CallState.ERROR,
    apiError: error,
  })),
);
